import { render, staticRenderFns } from "./CDN.vue?vue&type=template&id=720d76ae&scoped=true"
import script from "./CDN.vue?vue&type=script&lang=js"
export * from "./CDN.vue?vue&type=script&lang=js"
import style0 from "./CDN.vue?vue&type=style&index=0&id=720d76ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d76ae",
  null
  
)

export default component.exports